/**
 * The domain shown in the header when the real hostname can't be trusted —
 * local dev, an IP address, or a preview host.
 */
export const DEFAULT_DOMAIN = 'nawy.ae';

/**
 * Hostnames that are never a launch domain. Anchored on purpose: an unanchored
 * `localhost` would also reject a real domain that merely contains the word,
 * such as `nawy-localhost.com`.
 */
const DEV_OR_PREVIEW_HOST = [
  /^[\d.]+$/, // bare IPv4, e.g. 127.0.0.1
  /^localhost$/,
  /\.localhost$/,
  /(^|\.)claudeusercontent\.com$/, // the design canvas's own preview host
];

/**
 * Resolves the domain to display from a browser hostname.
 *
 * One build serves every launch domain (nawy.sa, nawy.iq, nawy.qa, …), so the
 * page reads its own hostname rather than baking a country in at build time.
 */
export function resolveDomain(hostname: string | undefined | null): string {
  const host = (hostname ?? '')
    .trim()
    .toLowerCase()
    .replace(/^www\./, '');

  const isLaunchDomain = host.includes('.') && !DEV_OR_PREVIEW_HOST.some((pattern) => pattern.test(host));

  return isLaunchDomain ? host : DEFAULT_DOMAIN;
}
